export class SseSessionEndedError extends Error {
	constructor() {
		super("SSE session ended");
		this.name = "SseSessionEndedError";
	}
}
